import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import storesWithoutGrowth from './StoresWithoutGrowth'
import storesWithoutGrowthDetail from './StoresWithoutGrowthDetail'

export const NAMESPACE = 'storeGrowth'
const INTERNAL_NAMESPACE = NAMESPACE + '/'
const _types = {
  getters: {
    METRICS: 'GETTER_METRICS',
    SORT_FIELD: 'GETTER_SORT_FIELD'
  },
  actions: {
    INIT_MODULE: 'INIT'
  },
  mutations: {
    SET_MAIN_METRIC: 'SET_MAIN_METRIC',
    SET_ACCUMULATED_SALES_DATE_OPTION: 'SET_ACCUMULATED_SALES_DATE_OPTION'
  }
}

const UNIT_METRICS = {
  normal: ['quantity_sold_1', 'quantity_sold_2', 'stock_quantity'],
  var: ['quantity_sold']
}

const PESOS_METRICS = {
  normal: ['real_sales_amount_1', 'real_sales_amount_2', 'stock_quantity'],
  var: ['real_sales_amount']
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    mainMetric: null,
    accumulatedSalesDateOption: null
  },
  getters: {
    [_types.getters.METRICS]: (state) => {
      if (state.mainMetric === 'UNITS') return UNIT_METRICS
      if (state.mainMetric === 'PESOS') return PESOS_METRICS
      else throw Error('métrica no implementada')
    },
    [_types.getters.SORT_FIELD]: (state, getters) => {
      const metricsNormalLength = getters[_types.getters.METRICS].normal.length
      const sortField = getters[_types.getters.METRICS].normal[metricsNormalLength - 1]
      return sortField
    }
  },
  actions: {
    async [_types.actions.INIT_MODULE] ({ commit }, { mainMetric, accumulatedSalesDateOption }) {
      commit(_types.mutations.SET_MAIN_METRIC, mainMetric)
      commit(_types.mutations.SET_ACCUMULATED_SALES_DATE_OPTION, accumulatedSalesDateOption)
    }
  },
  mutations: {
    [_types.mutations.SET_MAIN_METRIC] (state, mainMetric) {
      state.mainMetric = mainMetric
    },
    [_types.mutations.SET_ACCUMULATED_SALES_DATE_OPTION] (state, accumulatedSalesDateOption) {
      state.accumulatedSalesDateOption = accumulatedSalesDateOption
    }
  },
  modules: {
    storesWithoutGrowth,
    storesWithoutGrowthDetail
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/store_growth/store/Index.js